// Bu dosya, henüz tam olarak geliştirilmemiş sayfalar için geçici içerik sağlar
// Bu sayfa bileşenlerini ayrı dosyalara taşıyabilirsiniz

import React from 'react';
import { Link } from 'react-router-dom';
import { Settings, Users, FileText, BarChart2, ArrowLeft } from 'lucide-react';


// Ayarlar Sayfası
export const SettingsPage = () => {
  return (
    <div className="py-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-800">Sistem Ayarları</h1>
        <p className="text-gray-600">Bu sayfa henüz geliştirme aşamasındadır.</p>
      </div>
      
      <div className="bg-white rounded-lg shadow-md p-8 text-center">
        <div className="mx-auto w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mb-4">
          <Settings size={32} className="text-primary-600" />
        </div>
        <h2 className="text-xl font-bold text-gray-800 mb-2">Ayarlar Yakında</h2>
        <p className="text-gray-600 mb-6">
          Bu bölüm şu anda geliştirme aşamasındadır. Yakında sistem ayarları özellikleri eklenecektir.
        </p>
        <Link to="/dashboard" className="inline-flex items-center text-primary-600 hover:text-primary-800">
          <ArrowLeft size={16} className="mr-1" />
          Ana Sayfaya Dön
        </Link>
      </div>
    </div>
  );
};

// Raporlar Sayfası
export const ReportsPage = () => {
  return (
    <div className="py-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-800">Raporlar</h1>
        <p className="text-gray-600">Bu sayfa henüz geliştirme aşamasındadır.</p>
      </div>
      
      <div className="bg-white rounded-lg shadow-md p-8 text-center">
        <div className="mx-auto w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mb-4">
          <BarChart2 size={32} className="text-primary-600" />
        </div>
        <h2 className="text-xl font-bold text-gray-800 mb-2">Raporlar Yakında</h2>
        <p className="text-gray-600 mb-6">
          Bu bölüm şu anda geliştirme aşamasındadır. Yakında gelişmiş raporlama özellikleri eklenecektir.
        </p>
        <Link to="/dashboard" className="inline-flex items-center text-primary-600 hover:text-primary-800">
          <ArrowLeft size={16} className="mr-1" />
          Ana Sayfaya Dön
        </Link>
      </div>
    </div>
  );
};